<template>
  <div class="trainingWarning"
    :class="{'red': trainData.nearDays && trainData.nearDays <= 3}">
      <div class='base'>
        <!-- nearDays 可能为空 -->
        <template v-if="trainData">
          <p v-if="trainData.nearDays && trainData.nearDays > 3">
            为了帮助各位代理商更好了解产品功能，请在{{trainData.endTime}}日前，完成功能模块的培训，如果逾期未完成，该目录可能会被锁定！
          </p>
          <p v-else-if="trainData.nearDays && trainData.nearDays <= 3">
              {{ $t('common.trainingBannerCountdownPrefix') }}<span>{{trainData.nearDays}}</span>{{ $t('common.trainingBannerUrgentSuffix') }}</p>
        </template>
        <div class='goTraining' @click="goTraining()">{{ $t('common.trainingBannerGoTrain') }}</div>
      </div>
      <div class='close' @click="close()"></div>
  </div>
</template>

<script>
export default {
  name: 'bannerTips',
  data(){
    return {

    }
  },
  props: {
    trainData: {
      type: Object,
      default: () =>{}
    }
  },
  methods: {
    close() {
      // 直接调用父级关闭
      this.$emit('closeBannerTips');
      // 关闭后，刷新页面将不再显示
      localStorage.setItem('showBannerTips', false)
    },
    goTraining(){
      this.$emit('setModalVisible',true);
      // 直接跳转到钉钉学习 弹框
      this.$emit('bindDD',2);
    }
  }
}
</script>

<style lang="scss" scoped>
  .trainingWarning{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    width: 100%;
    height: 36px;
    min-height: auto;
    line-height: 36px;
    color: #fff;
    padding: 0 24px;
    border-radius: 0;
    box-sizing: border-box;
    background: #FF7D00;
    &.red{
      background: #FF4A46;
      p{
          span{
              font-size: 24px;
          }
      }
    }
    .base{
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    p{
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        margin-bottom: 0;
    }
    .goTraining{
        position: absolute;
        top: 6px;
        right: 54px;
        width: 104px;
        height: 24px;
        line-height: 22px;
        border-radius: 12px;
        text-align: center;
        border: 1px solid #FFFFFF;
        cursor: pointer;
    }
    .close{
        position: absolute;
        top: 8px;
        right: 8px;
        z-index: 3;
        width: 16px;
        height: 16px;
        background: url("../assets/images/accountUpdate/close.png") no-repeat;
        background-size: contain;
        cursor: pointer;
    }
  }
</style>